import { PublicApiRequestStatusEnum, PublicApiRequestStatusEnumLabels } from '@api/enum';
import { IClient, IUser } from '@api/models';
import { IPublicApiLogs } from '@api/models/analytics.model';
import { Table } from '@hyperflake/react-ui-library';
import { Chip } from '@library/chip';
import moment from 'moment';
import { Link } from 'react-router-dom';

interface PublicApiLogsListProps {
    isLoading: boolean;
    publicApiLogsData: IPublicApiLogs[];
}

const PublicApiLogsList = ({ isLoading, publicApiLogsData }: PublicApiLogsListProps) => {
    return (
        <Table
            className="mt-6"
            borderStyle="divider"
            hover={false}
            isLoading={isLoading}
            data={publicApiLogsData}
            columns={[
                { header: 'ID' },
                { header: 'Date' },
                { header: 'Client' },
                { header: 'User' },
                { header: 'Status' },
            ]}
            renderRow={(row) => (
                <Table.Row key={row._id}>
                    <Table.Cell>{row._id}</Table.Cell>

                    <Table.Cell>
                        <span>{moment(row.createdAt).format('HH:mm A - DD MMM YYYY')}</span>
                    </Table.Cell>

                    <Table.Cell>
                        <Link
                            to={`/clients/${(row.client as IClient)._id}/client-details`}
                            className="text-primary hover:underline"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {(row.client as IClient)?.name || '—'}
                        </Link>
                    </Table.Cell>

                    <Table.Cell>
                        <Link
                            to={`/clients/${(row.client as IClient)._id}/users/${(row.user as IUser)._id}/edit-user`}
                            className="text-primary hover:underline"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {(row.user as IUser)?.name || '—'}
                        </Link>
                    </Table.Cell>

                    <Table.Cell>
                        <Chip
                            label={PublicApiRequestStatusEnumLabels[row.status]}
                            color={row.status === PublicApiRequestStatusEnum.COMPELETED ? 'success' : 'warning'}
                            variant="outlined"
                        />
                    </Table.Cell>
                </Table.Row>
            )}
        />
    );
};

export default PublicApiLogsList;
